import { render, staticRenderFns } from "./integration-sync.vue?vue&type=template&id=22cd9cfd&scoped=true&"
import script from "./integration-sync.vue?vue&type=script&lang=js&"
export * from "./integration-sync.vue?vue&type=script&lang=js&"
import style0 from "./integration-sync.vue?vue&type=style&index=0&id=22cd9cfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd9cfd",
  null
  
)

export default component.exports